/* istanbul ignore file */
/* tslint:disable */
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { AddUsersSectionData, CreateDivisionSectionData, ExtendedCourseSection, PatchSectionData, ResultDataPostSectionCreateDivision, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function section(config) {
    const addUsersResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ExtendedCourseSection)),
    });
    const createDivisionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ResultDataPostSectionCreateDivision)),
    });
    const deleteResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ExtendedCourseSection)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ExtendedCourseSection)),
    });
    const deleteUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ExtendedCourseSection)),
    });
    return Object.freeze({
        /**
         * Add users to a course section.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the course section to add a user to.
         * @param arg.requestBody The body of the request.
         * @returns The updated course section.
         */
        addUsers: async ({ sectionId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/sections/${sectionId}/members/`, addUsersResponse.v, JSON.stringify(AddUsersSectionData.encode(requestBody)));
            return result;
        },
        /**
         * Connect users to a course section.
         *
         * Users that are already enrolled in the course connected to this section are immediately added to the course section. Other users will be added to the section as soon as they enroll in the course.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the course section to connect users to.
         * @param arg.requestBody The body of the request.
         * @returns The new division containing the users that were not immediately added to the course section.
         */
        createDivision: async ({ sectionId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/sections/${sectionId}/division`, createDivisionResponse.v, JSON.stringify(CreateDivisionSectionData.encode(requestBody)));
            return result;
        },
        /**
         * Delete a course section.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the section to delete.
         * @returns Nothing.
         */
        delete: async ({ sectionId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/sections/${sectionId}`, deleteResponse.v, undefined);
            return result;
        },
        /**
         * Get a course section.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the course section to get.
         * @returns The requested course section.
         */
        get: async ({ sectionId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/sections/${sectionId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Update a course section.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the course section to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated course section.
         */
        patch: async ({ sectionId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/sections/${sectionId}`, patchResponse.v, JSON.stringify(PatchSectionData.encode(requestBody)));
            return result;
        },
        /**
         * Remove a user from a course section.
         *
         * @param arg The arguments to the function.
         * @param arg.sectionId The id of the course section to remove the user from.
         * @param arg.userId The id of the user to remove from the course section.
         * @returns The updated course section.
         */
        deleteUser: async ({ sectionId, userId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/sections/${sectionId}/members/${userId}`, deleteUserResponse.v, undefined);
            return result;
        },
    });
}
